import React from "react";
import IconCardA from "components/mui/cards/iconCardA";
import { YellowDivider } from "components/mui/divider/divider";
import { WideContainer } from "components/mui/containers/PxftContainer";
import { Grid } from "@mui/material";
import Slide from "@mui/material/Slide";
import Grow from "@mui/material/Grow";
import { useInView } from "react-intersection-observer";

const Monetization = () => {
  const moneList = [
    {
      id: 1,
      icon: "demand",
      title: "Smarter Demand, Sourced by AI Agents",
      contents:
        "Our AI agents continuously evaluate and partner with the world's largest demand platforms — routing the highest-paying demand to your inventory in real time.",
      iconWidth: "65",
      iconHeight: "65",
      picsrc: "images/home/demand-pic.png",
    },
    {
      id: 2,
      icon: "revenue",
      title: "Agentic Deal Management for Agencies & Brands",
      contents:
        "AI agents handle deal negotiation signals, pacing, and brand-safety enforcement — scaling programmatic revenue without compromising quality.",
      iconWidth: "65",
      iconHeight: "65",
      picsrc: "images/home/intellegent-pic.png",
    },
    {
      id: 3,
      icon: "monetize",
      title: "Agentic AI That Maximizes Monetization Autonomously",
      contents:
        "Our agents don't just analyze — they act. Continuous bidding optimization, floor-price tuning, and yield decisions happen automatically, so revenue keeps climbing while you focus on content.",
      iconWidth: "65",
      iconHeight: "60",
      picsrc: "images/home/monetize-pic.png",
    },
  ];
  const [inViewRef, inView] = useInView({
    triggerOnce: true,
  });
  const containerRef = React.useRef(null);

  const [inViewRef0, inView0] = useInView({});
  const [inViewRef1, inView1] = useInView({});
  const [inViewRef2, inView2] = useInView({});
  let inViews = [inView0, inView1, inView2];
  let refs = [inViewRef0, inViewRef1, inViewRef2];
  let views = document.getElementsByClassName("monetize-tab-pic");

  return (
    <WideContainer className="home-monetization-container">
      <YellowDivider
        width="50px"
        height="120px"
        marginTop="0"
        marginRight="20%"
      />
      <div className="center-align">
        <Grid container className="monetization-content">
          <Slide
            timeout={{ enter: 1000 }}
            in={inView}
            direction="right"
            container={containerRef.current}
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={4.5}
              px={6}
              py={3}
              flexDirection="column"
            >
              <div className="monetize-tabs">
                {moneList.map((listItem, i) => (
                  <div
                    key={i}
                    onClick={() =>
                      views[i].scrollIntoView({
                        behavior: "smooth",
                        inline: "nearest",
                      })
                    }
                  >
                    <IconCardA IconCard={listItem} inview={inViews[i]} />
                  </div>
                ))}
              </div>
            </Grid>
          </Slide>
          <Grow timeout={{ enter: 800 }} in={inView}>
            <Grid item xs={12} sm={12} md={7.5} px={2}>
              {moneList.map((listItem, i) => (
                <div className="monetize-tab-pic" key={i}>
                  <div className="tabs">
                    <h4>{listItem.title}</h4>
                    <p>{listItem.contents}</p>
                  </div>
                  <img
                    loading="lazy"
                    className="contentPic"
                    src={"/" + listItem.picsrc}
                    alt="tab-pic"
                  />
                  <div className="observer" ref={refs[i]}></div>
                </div>
              ))}
            </Grid>
          </Grow>
        </Grid>
        <div className="long-observer" ref={inViewRef}></div>
      </div>
    </WideContainer>
  );
};

export default Monetization;
